import { useContext } from 'react'
import { PassContext } from '../../pass-context'
import PopupEditor from '../popup-editor'

import Card from './components/card'
import Logo from './components/logo'
import Barcode from './components/barcode'
import HeroImage from './components/hero-image'
import Fields from './components/fields'

const GoogleOfferFront = () => {
  try {
    return (
      <Card>
        <Logo/>
        <div className="inset offer">
          <OfferTitle/>
          <Fields/>
        </div>
        <Barcode/>
        <HeroImage/>
      </Card>
    )
  }
  catch (err) {
    throw err
  }
}

export default GoogleOfferFront


const OfferTitle = () => {

  const { classData } = useContext(PassContext)

  return (
    <PopupEditor title="Offer title" path="title" sources={["class"]}>
      <div className="title editable">{classData.title}</div>
    </PopupEditor>
  )
}

